additionalDigits